
function Subscribers() {
  return (
    <div className="subscribers pt-20 text-white" id="subs">
      <h1 className="text-5xl">SUBSCRIBERS PLANS</h1>
    </div>
  );
}

export default Subscribers;